import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PROMOTED_PETITION_UPDATE_EMAIL_PROMOTION_SETTINGS = createFcmDetails(
	'promoted_petition_update_email_promotion_settings',
	{
		owner: 'Site Platform',
		context: 'comms stack',
		import: false,
		description:
			'Defines the number of promotions and signature limit for including promoted petitions in petition update emails. Petitions that exceed the signature limit will not include promoted petitions',
		template: {
			promotions: 5,
			signatureLimit: 2000000,
		},
	},
);
